require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./project-daracombe-kew.json") })
        }
      }, "path---project-daracombe-kew");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---project-daracombe-kew!./.cache/json/project-daracombe-kew.json
// module id = 567
// module chunks = 231608221292675